import { StCryptographyProvider } from "./StCryptographyProvider";
import { StCryptographyProviderFactory } from "./StCryptographyProviderFactory";
import { StCryptographyType } from "./StCryptographyType";

export class StCryptoASymmetricOperator {
  private static instance: StCryptoASymmetricOperator | null = null;
  private cryptographyProvider: StCryptographyProvider;

  private constructor() {
    this.cryptographyProvider = StCryptographyProviderFactory.create(
      StCryptographyType.ASYMMETRIC
    );
  }

  static getInstance(): StCryptoASymmetricOperator {
    if (!StCryptoASymmetricOperator.instance) {
      StCryptoASymmetricOperator.instance = new StCryptoASymmetricOperator();
    }
    return StCryptoASymmetricOperator.instance;
  }

  encrypt(data: string, publicKey: string): Promise<string> {
    return this.cryptographyProvider.encrypt(data, publicKey);
  }

  decrypt(encryptedData: string, privateKey: string): Promise<string> {
    return this.cryptographyProvider.decrypt(encryptedData, privateKey);
  }
}